import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddressItem from '../../../../components/AddressItem';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import TypesService from '../../../../services/TypesService';
import { receiveSlice } from '../../../../store/slices/receive';
import './ReceiveAddress.scss';

const { routes } = AppConfig;

const BlockchainsById = TypesService.BlockchainsById;

const ReceiveAddress = () => {
	const asset = useSelector(state => state.receive.asset || {});

	const [accounts, setAccounts] = useState([]);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const GetAddressesByCurrency = useCallback(async assetId => {
		const res = await RequestService.GetAddressesByCurrency(assetId);

		setAccounts(res.Addresses || []);
	}, []);

	useEffect(() => {
		if (asset.Id) {
			GetAddressesByCurrency(asset.Id);
		}
	}, [asset.Id]);

	const onAccountClick = account => {
		dispatch(receiveSlice.actions.setAccount(account));
		navigate(routes.receiveQR);
	};

	const sortedAccounts = accounts?.sort((a, b) => {
		if (a?.AmountUsd < b?.AmountUsd) return 1;
		if (a?.AmountUsd > b?.AmountUsd) return -1;
		return 0;
	});

	return (
		<div className='ReceiveAddress'>
			<PageHeader
				icon={asset.Symbol.split('-')[0]}
				iconLabel={
					asset.Symbol !== BlockchainsById[asset.BlockchainId].Icon ? BlockchainsById[asset.BlockchainId].Icon : null
				}
				header={'Select address'}
				subheader={<>{asset.Name}</>}
			/>
			<div className='ReceiveAddress__body'>
				{sortedAccounts.length ? (
					<div className='ReceiveAddress__container FormBlock'>
						{sortedAccounts.map((account, index) => (
							<AddressItem
								key={index}
								address={account}
								onClick={() => onAccountClick(account)}
								lastItem={index === sortedAccounts.length - 1}
							/>
						))}
					</div>
				) : (
					<div className='ReceiveAddress__empty-state'>
						<Icon type={Icons.EMPTY_ACCOUNT_LIST_ICON} width={240} height={124} />
						<div className='ReceiveAddress__empty-header'>{t('No addresses yet')}</div>
						<div className='ReceiveAddress__empty-text'>{t('Creating wallet addresses…')}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default ReceiveAddress;
